import MenuItem from '../MenuItem'
const PopupMenuItem = MenuItem
export default PopupMenuItem
